var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{staticClass:"shadow-sm",model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}},_vm._l((_vm.regions),function({ _id, code, name }){return _c('option',{key:_id,domProps:{"value":code}},[_vm._v(" "+_vm._s(name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }